/**
 * Compare last two at_risk_pct points.
 * For risk share: up = worse, down = better.
 */
export function trendFromHistoryPoints(points) {
  if (!Array.isArray(points) || points.length < 2) {
    return { direction: 'none', delta: null };
  }

  const previous = Number(points[points.length - 2]?.at_risk_pct);
  const latest = Number(points[points.length - 1]?.at_risk_pct);

  if (!Number.isFinite(previous) || !Number.isFinite(latest)) {
    return { direction: 'none', delta: null };
  }

  const delta = Math.round((latest - previous) * 100) / 100;
  if (delta > 0) {
    return { direction: 'up', delta };
  }
  if (delta < 0) {
    return { direction: 'down', delta };
  }
  return { direction: 'flat', delta: 0 };
}

export function buildVersionTrendMap(historyPayload) {
  const map = new Map();
  for (const series of historyPayload?.series || []) {
    map.set(series.firmware_version, trendFromHistoryPoints(series.points));
  }
  return map;
}
